export default [

  {
    path: '/admin/admins',
    name: 'admins',
    component: () => import('@/views/apps/admin/colaboradores/viewAdministrador.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/admins/create',
    name: 'admins-create',
    component: () => import('@/views/apps/admin/colaboradores/createAdministrador.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/admins/edit/:id',
    name: 'admins-edit',
    component: () => import('@/views/apps/admin/colaboradores/editAdministrador.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },

  {
    path: '/admin/posts',
    name: 'posts',
    component: () => import('@/views/apps/admin/posts/viewPostAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/posts/create',
    name: 'posts-create',
    component: () => import('@/views/apps/admin/posts/createPostAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/posts/edit/:id',
    name: 'posts-edit',
    component: () => import('@/views/apps/admin/posts/editPostsAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },

  {
    path: '/admin/customers',
    name: 'customers',
    component: () => import('@/views/apps/admin/usuarios/viewUsuariosAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/customers/edit/:id',
    name: 'customers-edit',
    component: () => import('@/views/apps/admin/usuarios/editarUsuariosAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },

  {
    path: '/admin/specialists',
    name: 'specialists',
    component: () => import('@/views/apps/admin/especialistas/viewEspecialistaAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/specialists/create',
    name: 'specialists-create',
    component: () => import('@/views/apps/admin/especialistas/createEspecialistaAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/specialists/edit/:id',
    name: 'specialists-edit',
    component: () => import('@/views/apps/admin/especialistas/editarEspecialistaAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },

  {
    path: '/admin/balances',
    name: 'balances',
    component: () => import('@/views/apps/admin/movimentacoes/viewMovimentacoesAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },

  {
    path: '/admin/specialties',
    name: 'specialties',
    component: () => import('@/views/apps/admin/especialidades/viewEspecialidadesAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/specialties/create',
    name: 'specialties-create',
    component: () => import('@/views/apps/admin/especialidades/createEspecialidadesAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/specialties/edit/:id',
    name: 'specialties-edit',
    component: () => import('@/views/apps/admin/especialidades/editarEspecialidadesAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },

  {
    path: '/admin/variables/edit/:id',
    name: 'variables-edit',
    component: () => import('@/views/apps/admin/configuracoes/configuracoes.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/pages/list',
    name: 'pages-list',
    component: () => import('@/views/apps/admin/pages/List.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/pages/create',
    name: 'pages-create',
    component: () => import('@/views/apps/admin/pages/Create.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/page/ajuda-suporte',
    name: 'pages-edit-ajuda-suporte',
    component: () => import('@/views/apps/admin/pages/Edit.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/page/termo-condicoes',
    name: 'pages-edit-termo-condicoes',
    component: () => import('@/views/apps/admin/pages/Edit.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/page/sobre-app',
    name: 'pages-edit-sobre-app',
    component: () => import('@/views/apps/admin/pages/Edit.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
  {
    path: '/admin/page/politica-privacidade',
    name: 'pages-edit-politica-privacidade',
    component: () => import('@/views/apps/admin/pages/Edit.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },

  {
    path: '/admin/perfil',
    name: 'admin-perfil',
    component: () => import('@/components/perfil/AccountSetting.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/admin/logs/list',
    name: 'logs-list',
    component: () => import('@/views/apps/admin/logsErrors/logErrosAdmin.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },

  {
    path: '/admin/companies/details/:id',
    name: 'companyDetails',
    component: () => import('@/views/apps/admin/especialistas/components/businessGroupInformation.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },

  {
    path: '/admin/payments-transfers',
    name: 'payments_transfers_admin',
    component: () => import('@/views/apps/admin/payments_transfers/viewTransactions.vue'),
    meta: {
      resource: 'admin',
      action: 'manage',
    },
  },
]
